import momentTz from "moment-timezone";

var XLSX = require("xlsx");

export default {
    methods: {
        handleFileChange(e) {
            // var files = e.target.files,
            //  f = files[0];
            var reader = new FileReader();
            var self = this
            reader.onload = function (e) {

                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, {type: 'array', cellDates: false});
                self.excel.workbook = workbook
                self.excel.sheetNames = workbook.SheetNames
                self.excel.sheets = workbook.Sheets
                self.selectedSheet = workbook.SheetNames[0]
                // let sheetName = workbook.SheetNames[0]

                /* DO SOMETHING WITH workbook HERE */
                // console.log(workbook);
                // let worksheet = workbook.Sheets[sheetName];
                // console.log(XLSX.utils.sheet_to_json(worksheet));
            };
            reader.readAsArrayBuffer(e[0].file);
        },
        onBeforeDelete(e) {
            this.fileRecords = null
            this.selectedSheet = null
            this.excel = {
                workbook: null,
                sheetNames: [],
                sheets: [],
            }
        },
        fileDeleted(e) {
        },
        getParsedValue(key, map) {
            if (!map.value || !this.getRowData) {
                return ''
            }
            try {
                if (map.type === 'string') {
                    return this.getRowData[map.value]
                } else if (map.type === 'date') {

                    let momentDate = momentTz(this.getRowData[map.value], map.format).tz(map.timezone)
                    if (momentDate.isValid()) {
                        return momentDate.format(map.format)
                    } else {
                        return 'Date format does not match date'
                    }
                } else if (map.type === 'integer') {
                    let parsedValue = parseInt(this.getRowData[map.value])
                    if (isNaN(parsedValue)) {
                        return 'Value is not parsed as integer!'
                    } else {
                        return parsedValue
                    }
                } else if (map.type === 'float') {
                    let parsedValue = parseFloat(this.getRowData[map.value])
                    console.log(parsedValue,' is float',this.getRowData[map.value])

                    if (isNaN(parsedValue)) {
                        return 'Value is not parsed as integer!'
                    } else {
                        return parsedValue
                    }
                }

            } catch (e) {
                return e.message
            }
        },

        addCustomField() {
            this.customFields.push(
                {fieldName: '', type: 'string', value: null}
            )
        },
        removeCustomField(index){

              this.customFields.splice(index,1);

        }
    },
    computed: {
        getRandomHash() {
            var result = [];
            let strLength = 15;
            let charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            while (strLength--) { // (note, fixed typo)
                result.push(charSet.charAt(Math.floor(Math.random() * charSet.length)));
            }
            return '-' + this.getCompanyName.replace(' ', '-') + '-' + result.join('') + '@mailin.motivate.nl';
        },
        getPMTMapping() {
            let pmtMapping = _.clone(this.PMTMapping)
            let customFields = this.customFields
            _.each(customFields, field => {
                pmtMapping[field.fieldName] = {
                    type: field.type,
                    value: field.value
                }
            })
            return pmtMapping
        },
        getRowsFromExcel() {
            let sheetData = XLSX.utils.sheet_to_json(this.excel.workbook.Sheets[this.selectedSheet], {
                nullError: true,
                raw: false
            })
            return sheetData

        },

        timeZoneList() {
            return _.filter(momentTz.tz.names(), tz => {
                return tz.includes('Europe') || tz.toLowerCase().includes('utc') || tz.toLowerCase().includes('gmt')            })
        },
        getRowData() {
            let sheetData = XLSX.utils.sheet_to_json(this.excel.workbook.Sheets[this.selectedSheet], {
                nullError: true,
                raw: false
            })
            let row = this.excel.workbook.Sheets[this.selectedSheet][this.iterator]
            return sheetData[this.iterator]
        },
        getColumns() {
            const originalData = this.excel.workbook.Sheets[this.selectedSheet]
            let sheetData = XLSX.utils.sheet_to_json(originalData, {nullError: true, raw: false})
            return Object.keys(Object.assign({}, sheetData[0]))
        }
    }
};